import {
    apiRequest,
    flexytimeDetail,
    flexytimeUpdate
} from "../../../../../services/adapters/kepegawaian/flexytimeService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", flexytimeDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", flexytimeUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository